import React, { useContext } from 'react';
import { Redirect } from 'react-router-dom';

import UserContext from '../../../contexts/UserContext';

import './style.less';

const MessageReplyDetails = () => {
    const {
        userObject: {
            registrants: { list: listOfResidents, activeRegistrantsIndexes },
        },
    } = useContext(UserContext);

    return (
        <Redirect
            to={`/messages/${
                (listOfResidents[activeRegistrantsIndexes] && listOfResidents[activeRegistrantsIndexes]._id) ||
                listOfResidents[0]._id
            }`}
        />
    );
};

export default MessageReplyDetails;
